import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "e4a8971c-9ee7-408a-be10-7ad6cb9901e9",
    content: "0.09 Pa, i.e., -20 dB without absorption and<br>0.1 Pa, i.e., -22 dB accounting for absorption.",
    options: {},
  },
  {
    id: "8b85f0fe-a716-41af-86ab-ed8de202ddaf",
    content: "0.1 Pa, i.e., -20 dB without absorption and<br>0.09 Pa, i.e., -21 dB accounting for absorption.",
    options: {},
  },
  {
    id: "fa81a82e-a0ab-40be-b03a-d9598e69d051",
    content: "0.1 Pa, i.e., -21 dB without absorption and<br>0.1 Pa, i.e., -19 dB accounting for absorption.",
    options: {},
  },
  {
    id: "a3ec3a1b-8f38-401e-9608-d2196dd3ac84",
    content: "0.1 Pa, i.e., -20 dB without absorption and<br>0.08 Pa, i.e., -18 dB accounting for absorption.",
    options: {},
  },
];

export const task: Task = {
  id: "3a4c81ec-cfa8-46d6-94d3-3b2d3212afe9",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["8b85f0fe-a716-41af-86ab-ed8de202ddaf"],
};
